import { isNotFoundResponse } from "../../../../../lib/apiErrors.ts";
import type { PartnerBillOrCreditCardStatement } from "./partnerDocuments";

export const DOCUMENT_NO_LONGER_EXISTS_MESSAGE = "Dit document bestaat niet meer.";
export const DOCUMENT_COULD_NOT_OPEN_MESSAGE = "Het document kon niet worden geopend. Probeer het later opnieuw.";

export type DeepLinkedDocument = {
    businessId: string;
    documentId: string;
};

export type RouteDocument =
    | { kind: "listed"; document: PartnerBillOrCreditCardStatement }
    | { kind: "unlisted"; target: DeepLinkedDocument }
    | { kind: "unknown" };

export function findRouteDocument(
    documentId: string,
    clientId: string | null,
    documents: PartnerBillOrCreditCardStatement[],
): RouteDocument {
    const listed = documents.find((document) => document.id === documentId);
    if (listed) {
        return { kind: "listed", document: listed };
    }
    if (clientId) {
        return { kind: "unlisted", target: { businessId: clientId, documentId } };
    }
    return { kind: "unknown" };
}

export function deepLinkFailureMessage(error: unknown): string {
    return isNotFoundResponse(error) ? DOCUMENT_NO_LONGER_EXISTS_MESSAGE : DOCUMENT_COULD_NOT_OPEN_MESSAGE;
}
